/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const headerNavBarDropMenuSX: SxProps = {
	borderTopRightRadius: 0,
	borderTopLeftRadius: 0,
	maxWidth: 'calc(100vw - 40px)',
	boxShadow: 2,
	backgroundColor: 'background.paper',
	color: 'background.contrastText',
	'@media (hover: hover)': {
		py: 0,
		px: 1,
	},

	'.MuiTooltip-popper[data-popper-placement*="bottom"] > &': {
		'@media (hover: hover)': {
			mt: 0,
		},
		'@media (hover: none)': {
			mt: 0.75,
		},
	},
};

export const headerFlyoutMenuSX: SxProps = {
	borderRadius:0,
	overflowY:'auto',
	height:'100vh',
	backgroundColor: 'background.paper',
	minWidth:globalBreak({mobile:'80w', desktop:'30vw',desktopL:'25vw', desktopXL:'20vw'}),
	width:globalBreak({mobile:'80vw', desktop:'30vw',desktopL:'25vw', desktopXL:'20vw'}),
	boxShadow: 2,
	margin:0,
	'& > div':{
		px: globalBreak({mobile:3,desktop:5}),
	},
	'& ul':{
		p:0
	},
	color: 'background.contrastText',
	'@media (hover: hover)': {
		py: 0,
		px: 1,
	},

	'::-webkit-scrollbar': {
		width: 4
	},
	'::-webkit-scrollbar-track': {
		background: '#f1f1f1',
		marginTop: 0.5,
		marginBottom: 0.5
	},
	'::-webkit-scrollbar-thumb': {
		background: '#888'
	},
	'::-webkit-scrollbar-thumb:hover': {
		background: '#555'
	}
};


export const flyoutHeaderSX: SxProps = {
	minHeight: headerBreak({mobile:'9em', desktop:'16em'}),
	justifyContent:'flex-end',
	rowGap:2,
	'& #HeaderStoreLogo a > img':{
		height:'4em',
		width:'auto'
	},
	'& > svg':{
		fontSize:14
	}
}

export const flyoutHeaderLabelSX:SxProps = {
	alignItems:'center',
	display:"flex",
	justifyContent:'space-between',
	borderBottom:'1px solid', 
	width:'auto', 
	pb:globalBreak({mobile:1, desktop:1.5}), 
	mb:1, 
	fontWeight:700, 
	cursor:'pointer',
	fontSize:16,
	border:'none',
	'& *':{
		cursor:'pointer',
	},
	'& > span, & > p':{
		fontSize:16,
		fontWeight:700,
	}
}

export const headerFlyoutContentSX:SxProps = {
	'&:has(> :empty)':{
		display:'none'
	}
}

export const flyoutHeaderBackToSX:SxProps = {
	flexDirection:'row',
	columnGap:0.5,
	alignItems:'center',
	justifyContent:'flex-start',
	py:2,
	pr:2,
	cursor:'pointer',
	'& *':{
		cursor:'pointer',
		WebkitUserSelect: 'none',
		userSelect: 'none'
	},
	"& svg":{
		fontSize:12
	}
}

export const flyoutHeaderAllCatLabelSX:SxProps = {
	borderBottom:'1px solid', 
	width:'auto', 
	pb:1.5, 
	mb:1, 
	fontWeight:700,
	fontSize:16
}

export const headerFlyoutOverlaySX:SxProps = {
	position:'fixed',
	left:0,
	top:0,
	height:'100%',
	width:'100%',
	opacity:0.5,
	bgcolor:'#000',
	zIndex:1000
}